/**
 * DELETE /auth/revoke-session - Revoke specific session
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import { getCookie } from 'hono/cookie'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const revokeSessionAction: ActionDefinition = {
  key: 'revoke-session',
  label: { en: 'Revoke Session', es: 'Revocar sesión' },
  icon: 'mdi:close-circle',
  scope: 'module',
  hidden: true,
  method: 'DELETE',
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  input: {
    sessionId: { input: 'text', required: true, label: { en: 'Session ID', es: 'ID de sesión' } }
  },
  handler: async (ctx, input, c) => {
    const { sessionId, _authUserId } = input as { sessionId: string; _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const currentToken = c ? getCookie(c, 'refreshToken') : undefined

    const authService = ctx.services.get<AuthService>('auth')

    // Don't allow revoking current session (use logout for that)
    const sessions = await authService.getSessions(_authUserId, currentToken)
    const targetSession = sessions.find(s => s.id === sessionId)

    if (targetSession?.is_current) {
      throw new ctx.core.errors.AppError('Cannot revoke current session. Use logout instead.', 400)
    }

    const revoked = await authService.revokeSession(_authUserId, sessionId, getRequestInfo(c))

    if (!revoked) {
      throw new ctx.core.errors.NotFoundError('Session')
    }

    return { success: true }
  }
}
